// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Place component-specific SCSS in this file. It will apply only to this component's HTML */`, "",{"version":3,"sources":["webpack://./src/app/home-page/home-page.component.scss"],"names":[],"mappings":"AAAA,4FAAA","sourcesContent":["/* Place component-specific SCSS in this file. It will apply only to this component's HTML */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
